import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "article" }


import DownloadBtn from './downloadBtn.vue';

interface Prop {
  productName: string
  imgsrc: string
  downloadLink?: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'baseArticle',
  props: {
    productName: null,
    imgsrc: null,
    downloadLink: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_q_img = _resolveComponent("q-img")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_img, { src: __props.imgsrc }, null, 8, ["src"]),
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createVNode(DownloadBtn, {
      "product-name": __props.productName,
      "download-link": __props.downloadLink
    }, null, 8, ["product-name", "download-link"])
  ], 64))
}
}

})